import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import { ActionIconButton } from '@onesource/components';
import { FC, ReactElement } from 'react';

interface ReviewActionButtonProps {
  label: string;
  icon: ReactElement;
  onClick: () => void;
  disabled?: boolean;
  isLoading?: boolean;
}

/** A toolbar action: a labelled button from tablet up, an icon button with a tooltip on a phone. */
export const ReviewActionButton: FC<ReviewActionButtonProps> = ({ label, icon, onClick, disabled, isLoading }) => {
  const shownIcon = isLoading ? <CircularProgress size={16} color="inherit" /> : icon;
  return (
    <>
      <Button
        variant="outlined"
        color="inherit"
        onClick={onClick}
        disabled={disabled || isLoading}
        startIcon={shownIcon}
        sx={{ display: { xs: 'none', sm: 'inline-flex' }, flexShrink: 0, height: 40, whiteSpace: 'nowrap' }}
      >
        {label}
      </Button>
      <Box sx={{ display: { xs: 'flex', sm: 'none' } }}>
        <ActionIconButton
          tooltip={label}
          aria-label={label}
          icon={shownIcon}
          onClick={onClick}
          disabled={disabled || isLoading}
        />
      </Box>
    </>
  );
};
